import React from "react";

export default function AppButton({
  variant = "neutral",
  size = "md",
  iconOnly = false,
  className = "",
  children,
  ...props
}) {
  const classes = [
    "ds-button",
    variant === "primary" ? "ds-button--primary" : "",
    variant === "info" ? "ds-button--info" : "",
    variant === "error" ? "ds-button--error" : "",
    variant === "outlined" ? "ds-button--outlined" : "",
    variant === "neutral" ? "ds-button--neutral" : "",
    variant === "muted" ? "ds-button--muted" : "",
    size === "xs" ? "ds-button--xs" : "",
    size === "sm" ? "ds-button--sm" : "",
    size === "md" ? "ds-button--md" : "",
    size === "lg" ? "ds-button--lg" : "",
    iconOnly ? "ds-button--icon" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button type="button" className={classes} {...props}>
      {children}
    </button>
  );
}
